import React, {useRef} from 'react';
import {View, Animated} from 'react-native';

import Pressable from '~/components/controls/Pressable';
import RecommendIconFilled from '~/images/md-icons/recommend/materialsymbolsfilled/24px.svg';

const ApproveToggle = ({style, denied, onPress}) => {
  const translateAnim = useRef(new Animated.Value(denied ? 1 : 0)).current;
  const rotateAnim = useRef(new Animated.Value(denied ? 1 : 0)).current;
  const colorAnim = useRef(new Animated.Value(denied ? 1 : 0)).current;

  const rotateInterpolate = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '180deg'],
  });

  const colorInterpolate = colorAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['rgba(41, 153, 118, 1)', 'rgba(151, 39, 39, 1)'],
  });

  const translateInterpolate = translateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [24, 0],
  });

  return (
    <Pressable
      style={style}
      onPress={() => {
        const value = !denied;

        Animated.parallel([
          Animated.timing(rotateAnim, {
            toValue: value ? 1 : 0,
            duration: 200,
            useNativeDriver: true,
          }),
          Animated.timing(colorAnim, {
            toValue: value ? 1 : 0,
            duration: 200,
            useNativeDriver: true,
          }),
          Animated.timing(translateAnim, {
            toValue: value ? 1 : 0,
            duration: 200,
            useNativeDriver: true,
          }),
        ]).start(() => {
          onPress(value);
        });
      }}>
      <View
        style={{
          position: 'relative',
          display: 'block',
          height: 24,
          width: 48,
        }}>
        <Animated.View
          style={{
            position: 'absolute',
            display: 'block',
            top: 5,
            left: 7,
            height: 14,
            width: 34,
            borderRadius: 7,
            opacity: 0.4,
            backgroundColor: colorInterpolate,
          }}></Animated.View>
        <Animated.View
          style={{
            position: 'absolute',
            display: 'block',
            transform: [{rotateZ: rotateInterpolate}],
            left: translateInterpolate,
            backgroundColor: colorInterpolate,
            borderRadius: 90,
            height: 24,
            width: 24,
          }}>
          <RecommendIconFilled style={{fill: 'white'}} />
        </Animated.View>
      </View>
    </Pressable>
  );
};

export default ApproveToggle;
